// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.iptc-combobox
{
    position: relative;
    width: 100%;
}

.iptc-combobox-input
{
    box-sizing: border-box;
    width: 100%;
    height: 22px;

    padding: 4px 6px;

    background: #303030;
    color: #eeeeee;

    border: 1px solid #555;
    border-radius: 4px;

    outline: none;

    font-size: 12px;
}

.iptc-combobox-input:focus
{
    border-color: #7777ff;
}

.iptc-combobox-list {
    position: fixed;

    width: 470px;

    overflow-y: auto;
    overflow-x: hidden;

    background: #050505;

    border: 1px solid #808080;
    border-radius: 4px;

    z-index: 1000;
    margin: 0;
    transform: none;

    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.5);
}

/* Chrome / Edge / Chromium */
.iptc-combobox-list::-webkit-scrollbar {
    width: 6px;
}

.iptc-combobox-list::-webkit-scrollbar-track {
    background: transparent;
}

.iptc-combobox-list::-webkit-scrollbar-thumb {
    background: #9292ff;
    border-radius: 3px;
}

.iptc-combobox-list::-webkit-scrollbar-thumb:hover {
    background: #9292ff;
}
.iptc-combobox-item
{
    padding: 2px 4px;

    cursor: pointer;

    border-bottom: 1px solid #3a3a3a;
}

.iptc-combobox-item:hover,
.iptc-combobox-item.selected
{
    background: #383850;
}

/*
 * Parents
 */
.iptc-combobox-item:not(.child)
{
    background: #333333;
}

.iptc-combobox-item:not(.child):hover,
.iptc-combobox-item:not(.child).selected
{
    background: #383850;
}

/*
 * Children
 */
.iptc-combobox-item.child
{
    
    background: #252525;
}

.iptc-combobox-item.child:hover,
.iptc-combobox-item.child.selected
{
    background: #383850;
}

/*
 * Première ligne :
 * code + titre
 */
.iptc-item-title
{
    display: flex;
    align-items: baseline;

    gap: 12px;

    font-size: 14px;
}

.iptc-code
{
    color: #9292ff;

    font-family: monospace;

    white-space: nowrap;
}

.iptc-title
{
    color: #eeeeee;

    font-weight: 500;
}

/*
 * Parent du child
 */
.iptc-parent
{
    margin-top: 3px;
    margin-left: 20px;

    color: #8888aa;

    font-size: 12px;
}

/*
 * Définition
 */
.iptc-definition
{
    margin-top: 4px;

    color: #bbbbbb;

    font-size: 12px;

    line-height: 1.4;
}

.iptc-no-result
{
    padding: 12px;

    color: #888;

    text-align: center;

    font-size: 13px;
}
`, "",{"version":3,"sources":["webpack://./src/applications/appcode/appcomponents/sequences/iptccodecombobox.css"],"names":[],"mappings":"AAAA;;IAEI,kBAAkB;IAClB,WAAW;AACf;;AAEA;;IAEI,sBAAsB;IACtB,WAAW;IACX,YAAY;;IAEZ,gBAAgB;;IAEhB,mBAAmB;IACnB,cAAc;;IAEd,sBAAsB;IACtB,kBAAkB;;IAElB,aAAa;;IAEb,eAAe;AACnB;;AAEA;;IAEI,qBAAqB;AACzB;;AAEA;IACI,eAAe;;IAEf,YAAY;;IAEZ,gBAAgB;IAChB,kBAAkB;;IAElB,mBAAmB;;IAEnB,yBAAyB;IACzB,kBAAkB;;IAElB,aAAa;IACb,SAAS;IACT,eAAe;;IAEf,yCAAyC;AAC7C;;AAEA,6BAA6B;AAC7B;IACI,UAAU;AACd;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;AACA;;IAEI,gBAAgB;;IAEhB,eAAe;;IAEf,gCAAgC;AACpC;;AAEA;;;IAGI,mBAAmB;AACvB;;AAEA;;EAEE;AACF;;IAEI,mBAAmB;AACvB;;AAEA;;;IAGI,mBAAmB;AACvB;;AAEA;;EAEE;AACF;;;IAGI,mBAAmB;AACvB;;AAEA;;;IAGI,mBAAmB;AACvB;;AAEA;;;EAGE;AACF;;IAEI,aAAa;IACb,qBAAqB;;IAErB,SAAS;;IAET,eAAe;AACnB;;AAEA;;IAEI,cAAc;;IAEd,sBAAsB;;IAEtB,mBAAmB;AACvB;;AAEA;;IAEI,cAAc;;IAEd,gBAAgB;AACpB;;AAEA;;EAEE;AACF;;IAEI,eAAe;IACf,iBAAiB;;IAEjB,cAAc;;IAEd,eAAe;AACnB;;AAEA;;EAEE;AACF;;IAEI,eAAe;;IAEf,cAAc;;IAEd,eAAe;;IAEf,gBAAgB;AACpB;;AAEA;;IAEI,aAAa;;IAEb,WAAW;;IAEX,kBAAkB;;IAElB,eAAe;AACnB","sourcesContent":[".iptc-combobox\n{\n    position: relative;\n    width: 100%;\n}\n\n.iptc-combobox-input\n{\n    box-sizing: border-box;\n    width: 100%;\n    height: 22px;\n\n    padding: 4px 6px;\n\n    background: #303030;\n    color: #eeeeee;\n\n    border: 1px solid #555;\n    border-radius: 4px;\n\n    outline: none;\n\n    font-size: 12px;\n}\n\n.iptc-combobox-input:focus\n{\n    border-color: #7777ff;\n}\n\n.iptc-combobox-list {\n    position: fixed;\n\n    width: 470px;\n\n    overflow-y: auto;\n    overflow-x: hidden;\n\n    background: #050505;\n\n    border: 1px solid #808080;\n    border-radius: 4px;\n\n    z-index: 1000;\n    margin: 0;\n    transform: none;\n\n    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.5);\n}\n\n/* Chrome / Edge / Chromium */\n.iptc-combobox-list::-webkit-scrollbar {\n    width: 6px;\n}\n\n.iptc-combobox-list::-webkit-scrollbar-track {\n    background: transparent;\n}\n\n.iptc-combobox-list::-webkit-scrollbar-thumb {\n    background: #9292ff;\n    border-radius: 3px;\n}\n\n.iptc-combobox-list::-webkit-scrollbar-thumb:hover {\n    background: #9292ff;\n}\n.iptc-combobox-item\n{\n    padding: 2px 4px;\n\n    cursor: pointer;\n\n    border-bottom: 1px solid #3a3a3a;\n}\n\n.iptc-combobox-item:hover,\n.iptc-combobox-item.selected\n{\n    background: #383850;\n}\n\n/*\n * Parents\n */\n.iptc-combobox-item:not(.child)\n{\n    background: #333333;\n}\n\n.iptc-combobox-item:not(.child):hover,\n.iptc-combobox-item:not(.child).selected\n{\n    background: #383850;\n}\n\n/*\n * Children\n */\n.iptc-combobox-item.child\n{\n    \n    background: #252525;\n}\n\n.iptc-combobox-item.child:hover,\n.iptc-combobox-item.child.selected\n{\n    background: #383850;\n}\n\n/*\n * Première ligne :\n * code + titre\n */\n.iptc-item-title\n{\n    display: flex;\n    align-items: baseline;\n\n    gap: 12px;\n\n    font-size: 14px;\n}\n\n.iptc-code\n{\n    color: #9292ff;\n\n    font-family: monospace;\n\n    white-space: nowrap;\n}\n\n.iptc-title\n{\n    color: #eeeeee;\n\n    font-weight: 500;\n}\n\n/*\n * Parent du child\n */\n.iptc-parent\n{\n    margin-top: 3px;\n    margin-left: 20px;\n\n    color: #8888aa;\n\n    font-size: 12px;\n}\n\n/*\n * Définition\n */\n.iptc-definition\n{\n    margin-top: 4px;\n\n    color: #bbbbbb;\n\n    font-size: 12px;\n\n    line-height: 1.4;\n}\n\n.iptc-no-result\n{\n    padding: 12px;\n\n    color: #888;\n\n    text-align: center;\n\n    font-size: 13px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
